import React from "react";
import { Link as SmoothLink } from "react-scroll";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { GrDocumentUser } from "react-icons/gr";
import resume from "../Resume-Md-Muntasir-Hossain.pdf";

const Navbar = () => {
  const genericHamburgerLine = `h-0.5 w-8 my-[3px] rounded-full bg-black transition ease transform`;
  return (
    <>
      <div className=" navbar bg-gray-50 shadow-sm py-3 lg:px-10 px-5 sticky top-0 z-50 text-neutral">
        <div className="navbar-start">
          <SmoothLink
            activeclassname="active"
            to="home"
            spy={true}
            smooth={true}
            offset={-120}
            duration={600}
            isDynamic={true}
          >
            <img
              src="Images/logo.png"
              className="w-14 h-[48.88px]"
              alt="logo"
            />
          </SmoothLink>
        </div>
        {/* pc */}
        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal clild:p-0 child:mx-3 uppercase  p-0 font-[500]">
            <li>
              <SmoothLink
                activeclassname="active"
                to="home"
                spy={true}
                smooth={true}
                offset={-120}
                duration={600}
                isDynamic={true}
              >
                Home
              </SmoothLink>
            </li>
            <li>
              <SmoothLink
                activeclassname="active"
                to="projects"
                spy={true}
                smooth={true}
                offset={-135}
                duration={600}
                isDynamic={true}
              >
                Projects
              </SmoothLink>
            </li>
            <li>
              <SmoothLink
                to="skills"
                spy={true}
                smooth={true}
                offset={-70}
                duration={600}
                isDynamic={true}
              >
                Skills
              </SmoothLink>
            </li>
            <li>
              <SmoothLink
                activeclassname="active"
                to="about"
                spy={true}
                smooth={true}
                offset={-135}
                duration={600}
                isDynamic={true}
              >
                About
              </SmoothLink>
            </li>
            <li>
              <SmoothLink
                activeclassname="active"
                to="contact"
                spy={true}
                smooth={true}
                offset={-75}
                duration={600}
                isDynamic={true}
              >
                Contact
              </SmoothLink>
            </li>
          </ul>
        </div>
        <div className="navbar-end gap-6 child:text-gray-700 child:text-xl lg:flex hidden">
          <a
            title="Github"
            href="https://github.com/MuntasirTonmoy"
            target="_blank"
            rel="noreferrer"
          >
            <BsGithub className="hover:scale-110 transition-scale duration-300"></BsGithub>
          </a>
          <a
            title="LinkedIn"
            href="https://www.linkedin.com/in/md-muntasir-hossain-a18169241/"
            target="_blank"
            rel="noreferrer"
          >
            <BsLinkedin className="hover:scale-110 transition-scale duration-300"></BsLinkedin>
          </a>
          <a
            title="Resume"
            href={resume}
            download="Resume-Md-Muntasir-Hossain.pdf"
          >
            <GrDocumentUser className="animate-bounce hover:scale-110 transition-scale duration-300"></GrDocumentUser>
          </a>
        </div>
        <div className="navbar-end lg:hidden flex">
          <div className=" gap-6 child:text-gray-700 child:text-xl lg:hidden flex">
            <a
              href="https://github.com/MuntasirTonmoy"
              target="_blank"
              rel="noreferrer"
            >
              <BsGithub className="hover:scale-110 transition-scale duration-300"></BsGithub>
            </a>
            <a
              href="https://www.linkedin.com/in/md-muntasir-hossain-a18169241/"
              target="_blank"
              rel="noreferrer"
            >
              <BsLinkedin className="hover:scale-110 transition-scale duration-300"></BsLinkedin>
            </a>
            <a
              title="Resume"
              href={resume}
              download="Resume-Md-Muntasir-Hossain.pdf"
            >
              <GrDocumentUser className="animate-bounce hover:scale-110 transition-scale duration-300"></GrDocumentUser>
            </a>
          </div>
          <div className="dropdown  dropdown-end">
            <label tabIndex="0">
              <button className="ml-6 flex flex-col h-12 w-12 justify-center items-center group">
                <div className={`${genericHamburgerLine} `} />
                <div className={`${genericHamburgerLine}`} />
                <div className={`${genericHamburgerLine}`} />
              </button>
            </label>
            <ul
              tabIndex="0"
              className="shadow mt-8 menu  dropdown-content bg-base-100 rounded-box w-52"
            >
              {/* mobile */}
              <li>
                <SmoothLink
                  activeclassname="active"
                  to="home"
                  spy={true}
                  smooth={true}
                  offset={-120}
                  duration={600}
                  isDynamic={true}
                >
                  Home
                </SmoothLink>
              </li>
              <li>
                <SmoothLink
                  activeclassname="active"
                  to="projects"
                  spy={true}
                  smooth={true}
                  offset={-110}
                  duration={600}
                  isDynamic={true}
                >
                  Projects
                </SmoothLink>
              </li>
              <li>
                <SmoothLink
                  activeclassname="active"
                  to="skills"
                  spy={true}
                  smooth={true}
                  offset={-75}
                  duration={600}
                  isDynamic={true}
                >
                  Skills
                </SmoothLink>
              </li>
              <li>
                <SmoothLink
                  activeclassname="active"
                  to="about"
                  spy={true}
                  offset={-105}
                  smooth={true}
                  duration={600}
                  isDynamic={true}
                >
                  About
                </SmoothLink>
              </li>
              <li>
                <SmoothLink
                  activeclassname="active"
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={-75}
                  duration={600}
                  isDynamic={true}
                >
                  Contact
                </SmoothLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
